import { render } from "./ArmorsView.vue?vue&type=template&id=0aea7519&scoped=true"
import script from "./ArmorsView.vue?vue&type=script&lang=js"
export * from "./ArmorsView.vue?vue&type=script&lang=js"

import "./ArmorsView.vue?vue&type=style&index=0&id=0aea7519&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aea7519"]])

export default __exports__